<template>
    <div>
        <b-container fluid>
            <h3 class="mt-3 mb-3">Tracking Location</h3>

            <div class="row">
                <div class="col-2 pr-0">
                    <b-form-select size="sm" v-model="location_update_obj.client_selected" :options="client_options" />
                </div>
                <div class="col-2 pr-0">
                    <b-form-input id="input-small" size="md" type="date"
                        v-model="location_update_obj.collection_date"></b-form-input>
                </div>
                <div class="col-2 pr-0">
                    <b-form-input size="md" type="text" v-model="location_update_obj.tracking_location"
                        placeholder="Tracking Location" />
                </div>

                <div class="col-3 pr-0">
                    <b-form-input size="md" type="text" v-model="location_update_obj.tracking_number"
                        v-on:keyup.enter="onSubmit(location_update_obj.tracking_number)" placeholder="Tracking #" />
                </div>

                <div class="col-3">
                    <b-button class="btn-action" size="md" variant="info"
                        @click="onSubmit(location_update_obj.tracking_number)"
                        :disabled="!location_update_obj.tracking_location || !location_update_obj.tracking_number" v-if="checkPermission(
                        $store.state.user_obj,
                        'Delivery Management',
                        'Tracking Location',
                        'Tracking Location',
                        true
                    )
                        ">Submit</b-button>

                    <b-button v-if="checkPermission(
                        $store.state.user_obj,
                        'Delivery Management',
                        'Tracking Location',
                        'Tracking Location',
                        true)" class="btn-action ml-2" size="md" variant="info" @click="openScanner">Scan</b-button>
                </div>
            </div>

            <div class="row mt-2">
                <div class="col">
                    <b-alert :show="alert_config.show" :variant="alert_config.variant"
                        @dismissed="alert_config.show = false" dismissible>
                        {{ alert_config.message }}
                    </b-alert>
                </div>
            </div>

            <div class="row m-1" v-if="scannerOn">
                <b-button block class="btn-action mb-1" size="md" variant="danger" @click="closeScanner()"
                    v-if="scannerOn">Close</b-button>
                <StreamBarcodeReader style="width: 100%;" @decode="onDecode" @loaded="onLoaded"></StreamBarcodeReader>
            </div>

            <h4>Scan History</h4>
            <b-table responsive small outlined striped hover sticky-header="500px" :items="scan_history"
                :fields="fields">
            </b-table>
        </b-container>
    </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";
import apiService from "../services/ApiService";
import global_function from "../mixins/global_function";
import { StreamBarcodeReader } from "vue-barcode-reader";

export default {
    name: "OrderMaster",
    inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT", "NODEJS_API_URL"],
    mixins: [apiService, global_function],
    components: {
        barcode: VueBarcode,
        StreamBarcodeReader
    },
    data() {
        return {
            result: null,
            location_update_obj: {
                client_selected: "RMW",
                tracking_location: null,
                tracking_number: null,
                collection_date: moment().format("YYYY-MM-DD")
            },

            scan_history: [],

            scannerOn: false,

            alert_config: {
                show: false,
                variant: "danger",
                message: ""
            },

            client_options: [
                {
                    value: "RMW",
                    text: "RMW",
                },
            ],

            fields: [
                {
                    key: "date",
                    label: "Date"
                },
                {
                    key: "time",
                    label: "Time"
                },
                {
                    key: "tracking_number",
                    label: "Tracking #"
                },
                {
                    key: "order_number",
                    label: "Order #"
                },
                {
                    key: "tracking_location",
                    label: "Location"
                }
            ],

            camera_cooldown: false
        };
    },
    async created() {
        this.initialized = true;
    },
    mounted() { },
    watch: {},
    methods: {
        async onDecode(content) {
            if (this.scannerOn && !this.camera_cooldown) {
                this.result = content;
                this.onSubmit(content);
            }
        },
        onLoaded() {
            console.log("loaded barcode reader");
        },
        async onSubmit(tracking_number) {
            this.alert_config = {
                show: false,
                variant: "danger",
                message: ""
            };

            if (!tracking_number || tracking_number === "") return;

            if (this.location_update_obj.client_selected == 'RMW') {
                this.location_update_obj.tracking_number =
                    this.location_update_obj.tracking_number.replace(/^0+/, "");

                await this.printPdf();

            }

            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "tracking_location_scan.php",
                data: {
                    location_update_obj: {
                        ...this.location_update_obj,
                        tracking_number
                    },
                    client_id: this.$store.state.user_obj.client_id,
                    user_id: this.$store.state.user_obj.user_id
                }
            });

            this.camera_cooldown = true;
            setTimeout(() => (this.camera_cooldown = false), 2000);

            if (response.data.status === "success") {
                this.alert_config = {
                    show: true,
                    variant: "success",
                    message: "Location is updated"
                };

                this.scan_history = [
                    ...response.data.orders,
                    ...this.scan_history
                ];
            } else {
                this.alert_config = {
                    show: true,
                    variant: "danger",
                    message: `[${tracking_number}] ${response.data.message}`
                };
            }
        },

        async printPdf() {

            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "tracking_log_print_pdf.php",
                data: {
                    tracking_number: this.tracking_search.tracking_number,
                    account_type: this.$store.state.user_obj.account_type,
                    client_id: this.$store.state.user_obj.client_id,
                    user_id: this.$store.state.user_obj.user_id
                }
            });

            let self = this;
            
            let pdf_to_print_src = encodeURIComponent('GOLS_PDF' +
                "/" +
                this.tracking_obj.tracking_number);
            this.pdf_to_print = "https://sys.gols.com.hk/api/download_ftp_waybill.php?url=" + pdf_to_print_src;

            setTimeout(() => {
                let objFra = document.getElementById("myFrame");
                objFra.contentWindow.focus();
                objFra.contentWindow.print();
            }, 4000);

            let tracking_number = this.tracking_search.tracking_number;

            setTimeout(() => {
                self.loader.hide();

                fetch(self.pdf_to_print).then(function (t) {
                    return t.blob().then(b => {
                        var a = document.createElement("a");
                        a.href = URL.createObjectURL(b);
                        // a.setAttribute("download", self.pdf_to_print.split("/").pop());
                        a.setAttribute("download", tracking_number + ".pdf");
                        a.click();
                    });
                });

                self.tracking_search = {};
                self.tracking_obj = false;
                this.$refs["txt_tracking_number"].$el.focus();
            }, 6000);

            await sleep(6000);

            this.loader.hide();
            this.tracking_search = {};
            this.tracking_obj = false;
            this.$refs["txt_tracking_number"].$el.focus();
        },
        openScanner() {
            this.scannerOn = true;
        },
        closeScanner() {
            this.scannerOn = false;
        },

        async printPdf() {

            let self = this;
            let pdf_to_print_src = encodeURIComponent('GOLS_PDF' +
                "/" +
                this.tracking_obj.tracking_number);
            this.pdf_to_print = "https://sys.gols.com.hk/api/download_ftp_waybill.php?url=" + pdf_to_print_src;

            setTimeout(() => {
                let objFra = document.getElementById("myFrame");
                objFra.contentWindow.focus();
                objFra.contentWindow.print();
            }, 4000);

            setTimeout(() => {
                self.loader.hide();

                fetch(self.pdf_to_print).then(function (t) {
                    return t.blob().then(b => {
                        var a = document.createElement("a");
                        a.href = URL.createObjectURL(b);
                        a.setAttribute("download", self.tracking_obj.tracking_number + ".pdf");
                        a.click();
                    });
                });

                self.loader.hide();
                self.tracking_search = {};
                self.tracking_obj = false;
                self.$refs["txt_tracking_number"].$el.focus();
            }, 6000);
        }
    }
};
</script>

<style>
th,
td {
    white-space: nowrap;
}

.span-status {
    display: none;
}

.container-status:hover .span-status {
    display: inline;
}

.row-status_cnt {
    display: flex;
}

.scanner-container video {
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/TrackingLocationScan.vue